import React, { Component } from "react";
import { Table, Button, Col, Row, Tooltip } from "antd";
import axios from "axios";
import PrintModalCupom from '../components/PrintModalCupom';
import moment from "moment-timezone";
import numeral from "numeral";
import "./Relatorios.css";
import Colors from "../utils/Colors";
import { getUsuario } from "../utils/LoginManager";
import { maskCNPJ } from '../utils/Masker';

const { Column } = Table;

class OSPrintCupomModal extends Component {
    state = {
        registro: [],
        os_idf: 0,
        vlr_prod: 0,
        vlr_serv: 0,
        vlr_avul: 0,
        vlr_total: 0,
        listaProdutos: [],
        listaParcelas: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if ((this.props.visivel !== propsAnte.visivel) && (this.props.os_idf)) {
            this.setState({
                os_idf: this.props.os_idf,
                registro: [],
                visualizar: true,
            });
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { os_idf } = this.props;

        axios
            .get(`/ordem_servicos/show/${os_idf}`)
            .then(response => {
                const { data } = response;

                // console.log('getListaRegistros: ', data);

                let listaProdutos = [];
                let vlr_prod = 0;
                let vlr_serv = 0;
                let vlr_avul = 0;
                let vlr_total = 0;

                for (var x in data.listaProdutos) {
                    vlr_prod = vlr_prod + parseFloat(data.listaProdutos[x].mi_vlr_total);

                    listaProdutos.push({
                        ven_idf: 0,
                        venc_idf: 0,
                        mi_idf_condicional: 0,
                        mi_idf: data.listaProdutos[x].mi_idf,
                        mi_item: data.listaProdutos[x].mi_item,
                        mi_servico: { key: '0' },
                        mi_item_Avulso: '',
                        mi_seq: listaProdutos.length + 1,
                        prod_idf: data.listaProdutos[x].prod_idf,
                        pest_qtde: data.listaProdutos[x].pest_qtde,
                        prod_grade: data.listaProdutos[x].prod_grade,
                        mi_item_tamanho: data.listaProdutos[x].mi_item_tamanho,
                        mi_item_cor: data.listaProdutos[x].mi_item_cor,
                        ptam_descricao: data.listaProdutos[x].ptam_descricao,
                        pcor_descricao: data.listaProdutos[x].pcor_descricao,
                        prod_codigo: data.listaProdutos[x].prod_codigo,
                        prod_descricao: data.listaProdutos[x].prod_descricao,
                        prod_cod_barras: data.listaProdutos[x].prod_cod_barras,
                        mi_qtde: parseFloat(data.listaProdutos[x].mi_qtde),
                        mi_vlr_unit: parseFloat(data.listaProdutos[x].mi_vlr_unit),
                        mi_vlr_venda: parseFloat(data.listaProdutos[x].mi_vlr_venda),
                        mi_vlr_venda_min: parseFloat(data.listaProdutos[x].mi_vlr_venda_min),
                        mi_perc_desc: parseFloat(data.listaProdutos[x].mi_perc_desc),
                        mi_vlr_desc: parseFloat(data.listaProdutos[x].mi_vlr_desc),
                        mi_vlr_acres: parseFloat(data.listaProdutos[x].mi_vlr_acres),
                        mi_vlr_total: parseFloat(data.listaProdutos[x].mi_vlr_total),
                        mi_calc_estoque: parseFloat(data.listaProdutos[x].mi_calc_estoque),
                        tipoItem: 'P',
                    });
                };

                for (var x in data.listaServicos) {
                    vlr_serv = vlr_serv + parseFloat(data.listaServicos[x].osis_vlr_total);

                    listaProdutos.push({
                        ven_idf: 0,
                        venc_idf: 0,
                        mi_idf_condicional: 0,
                        mi_item: { key: '0' },
                        mi_servico: data.listaServicos[x].osis_servico,
                        mi_item_Avulso: '',
                        mi_seq: listaProdutos.length + 1,
                        prod_idf: '',
                        pest_qtde: 0,
                        prod_grade: '',
                        mi_item_tamanho: '',
                        mi_item_cor: '',
                        ptam_descricao: '',
                        pcor_descricao: '',
                        prod_codigo: '',
                        prod_descricao: data.listaServicos[x].serv_descricao,
                        prod_cod_barras: '',
                        mi_qtde: parseFloat(data.listaServicos[x].osis_qtde),
                        mi_vlr_unit: parseFloat(data.listaServicos[x].osis_vlr_unit),
                        mi_vlr_venda: parseFloat(data.listaServicos[x].osis_vlr_unit),
                        mi_vlr_venda_min: parseFloat(data.listaServicos[x].osis_vlr_unit),
                        mi_perc_desc: 0,
                        mi_vlr_desc: 0,
                        mi_vlr_acres: 0,
                        mi_vlr_total: parseFloat(data.listaServicos[x].osis_vlr_total),
                        mi_calc_estoque: 0,
                        tipoItem: 'S',
                    });
                };

                for (var x in data.listaAvulsos) {
                    vlr_avul = vlr_avul + parseFloat(data.listaAvulsos[x].osia_vlr_total);

                    listaProdutos.push({
                        ven_idf: 0,
                        venc_idf: 0,
                        mi_idf_condicional: 0,
                        mi_item: { key: '0' },
                        mi_servico: 0,
                        mi_item_Avulso: data.listaAvulsos[x].osia_descricao,
                        mi_seq: listaProdutos.length + 1,
                        prod_idf: '',
                        pest_qtde: 0,
                        prod_grade: '',
                        mi_item_tamanho: '',
                        mi_item_cor: '',
                        ptam_descricao: '',
                        pcor_descricao: '',
                        prod_codigo: '',
                        prod_descricao: data.listaAvulsos[x].osia_descricao,
                        prod_cod_barras: '',
                        mi_qtde: parseFloat(data.listaAvulsos[x].osia_qtde),
                        mi_vlr_unit: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
                        mi_vlr_venda: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
                        mi_vlr_venda_min: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
                        mi_perc_desc: 0,
                        mi_vlr_desc: 0,
                        mi_vlr_acres: 0,
                        mi_vlr_total: parseFloat(data.listaAvulsos[x].osia_vlr_total),
                        mi_calc_estoque: 0,
                        tipoItem: 'A',
                    });
                };

                this.setState({
                    registro: data.dados,
                    listaProdutos: listaProdutos,
                    listaParcelas: data.listaParcelas,
                    vlr_prod,
                    vlr_serv,
                    vlr_avul,
                    vlr_total: vlr_prod + vlr_serv + vlr_avul,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            os_idf: 0,
            registro: [],
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderTipoItem = (tipo) => {
        return (
            <span> {tipo === 'P' ? 'Prod' : (tipo === 'S' ? 'Serv' : 'Avul')} </span>
        );
    };

    renderDescrProduto = (prod_descricao, registro) => {
        return (
            <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
        );
    };

    renderCheckListSelect = (checkListSelect) => {
        let check = '';
        for (var x in checkListSelect) {
            check = check + checkListSelect[x].clos_descricao + '; ';
        }
        return (
            <span> {check} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }

    renderDataParc = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }

    renderProdutos = () => {
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        // console.log('renderProdutos listaRegistros: ', this.state.listaProdutos);

        const content = this.state.listaProdutos.map((post, index) =>
            <Col xs={24}  >
                <div style={{ color: "black" }}>
                    <Col xs={4} style={{ fontSize: 10, textAlign: "left" }} >
                        <span>{this.renderTipoItem(post.tipoItem)}</span>
                    </Col>
                    <Col xs={5} style={{ fontSize: 10, textAlign: "left" }} >
                        <span>{zeroPad(post.prod_codigo, 6)}</span>
                    </Col>
                    <Col xs={5} style={{ fontSize: 10, textAlign: "right" }} >
                        <span>{this.renderValor(post.mi_qtde)}</span>
                    </Col>
                    <Col xs={5} style={{ fontSize: 10, textAlign: "right" }} >
                        <span>{this.renderValor(post.mi_vlr_unit)}</span>
                    </Col>
                    <Col xs={5} style={{ fontSize: 10, textAlign: "right" }} >
                        <span>{this.renderValor(post.mi_vlr_total)}</span>
                    </Col>
                    <Col xs={24} style={{ fontSize: 10, height: 22, textAlign: "left" }} >
                        <span>{post.prod_descricao}</span>
                    </Col>
                </div>
            </Col>
        );

        return (
            <div style={{ color: "black" }}>
                <Col xs={4} style={{ fontSize: 11, textAlign: "left" }} >
                    <span style={{ fontWeight: "bold" }}>Tipo </span>
                </Col>
                <Col xs={5} style={{ fontSize: 11, textAlign: "left" }} >
                    <span style={{ fontWeight: "bold" }}>Codigo </span>
                </Col>
                <Col xs={5} style={{ fontSize: 11, textAlign: "right" }} >
                    <span style={{ fontWeight: "bold" }}>Qtde </span>
                </Col>
                <Col xs={5} style={{ fontSize: 11, textAlign: "right" }} >
                    <span style={{ fontWeight: "bold" }}>Preço </span>
                </Col>
                <Col xs={5} style={{ fontSize: 11, textAlign: "right" }} >
                    <span style={{ fontWeight: "bold" }}>Total </span>
                </Col>
                <Col xs={24} style={{ fontSize: 11, textAlign: "left" }} >
                    <span style={{ fontWeight: "bold" }}>Descrição </span>
                </Col>
                <Col xs={24} style={{ fontSize: 11, textAlign: "left" }} >
                    <div style={{ marginTop: 5, height: 1, backgroundColor: Colors.background }} />
                </Col>
                {content}
            </div>
        );

    };

    renderPagamentos = () => {
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        // console.log('renderPagamentos listaRegistros: ', this.state.listaProdutos);

        const content = this.state.listaParcelas.map((post, index) =>
            <Col xs={24}  >
                <div style={{ color: "black" }}>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "left" }} >
                        <span>{zeroPad(post.tparc_parcela, 3)}</span>
                    </Col>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "left" }} >
                        <span>{this.renderDataParc(post.tparc_data_parcela)}</span>
                    </Col>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "right" }} >
                        <span>{this.renderValor(post.tparc_valor)}</span>
                    </Col>
                    <Col xs={6} style={{ fontSize: 10, height: 22, textAlign: "center" }} >
                        <span>{post.situacao_parcela}</span>
                    </Col>
                </div>
            </Col>
        );

        return (
            <div style={{ color: "black" }}>
                <Col xs={6} style={{ fontSize: 11, textAlign: "left" }} >
                    <span style={{ fontWeight: "bold" }}>Parcela </span>
                </Col>
                <Col xs={6} style={{ fontSize: 11, textAlign: "left" }} >
                    <span style={{ fontWeight: "bold" }}>Data </span>
                </Col>
                <Col xs={6} style={{ fontSize: 11, textAlign: "right" }} >
                    <span style={{ fontWeight: "bold" }}>Valor </span>
                </Col>
                <Col xs={6} style={{ fontSize: 11, textAlign: "center" }} >
                    <span style={{ fontWeight: "bold" }}> </span>
                </Col>
                {content}
            </div>
        );

    };

    render() {
        const { onCancelarPrintClick, visivel } = this.props;
        const { carregando, visualizar, listaProdutos, listaParcelas, vlr_avul, vlr_prod, vlr_serv, vlr_total } = this.state;
        const { os_numero, os_data_emissao, pes_codigo, pes_nome, usu_nome,
            cp_descricao, pes_fone1, pes_fone2, pes_fone3,
            pes_endereco, pes_numero, pes_bairro, pes_cep, cmun_descricao, cuf_sigla,
            os_descricao, os_solicitante, oso_defeitos, oso_laudo, checkListSelect } = this.state.registro;

        // console.log('OrdemServicoPrintModal: ', this.state.registro);
        const usuario = getUsuario();
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        return (
            <span style={{}}>
                <PrintModalCupom
                    visible={visivel}
                    onCancel={onCancelarPrintClick}
                >
                    <div style={{}}>
                        <div className="titulo1" style={{ marginTop: 0, marginLeft: 0 }}>
                            <div>
                                <span style={{ fontSize: 12, fontWeight: 'bold' }}>
                                    {usuario.emp_nome}
                                </span>
                            </div>
                            <div style={{}}>
                                <span style={{ fontSize: 8 }}>
                                    {usuario.emp_cpf_cnpj ? maskCNPJ(usuario.emp_cpf_cnpj) : ''}
                                    {usuario.emp_fone1 ? ' - ' + usuario.emp_fone1 : ''}
                                    {usuario.emp_fone2 ? ' - ' + usuario.emp_fone2 : ''}
                                    {usuario.emp_fone3 ? ' - ' + usuario.emp_fone3 : ''}
                                </span>
                            </div>
                            <div style={{}}>
                                <span style={{ fontSize: 8 }}>
                                    {usuario.emp_endereco ? usuario.emp_endereco : ''}
                                    {usuario.emp_numero ? ' nº ' + usuario.emp_numero : ''}
                                    {usuario.emp_complemento ? ' ' + usuario.emp_complemento : ''}
                                    {usuario.emp_bairro ? ' - ' + usuario.emp_bairro : ''}
                                    {usuario.cmun_descricao ? ' - ' + usuario.cmun_descricao : ''}
                                    {usuario.cuf_sigla ? ' - ' + usuario.cuf_sigla : ''}
                                </span>
                            </div>
                        </div>

                        <div style={{ marginTop: 5, height: 1, backgroundColor: "black" }} />

                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0, color: "black" }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10 }}>{zeroPad(os_numero, 6)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0, color: "black" }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10 }}>Data: </span>
                                <span style={{ fontSize: 10 }}> {this.renderData(os_data_emissao)} </span>
                            </div>
                        </Row>

                        <Row className="titulo1" style={{ fontSize: 12, fontWeight: 'bold' }}>
                            ORDEM DE SERVIÇO
                        </Row>

                        <div style={{ marginTop: 5, height: 1, backgroundColor: "black" }} />

                        <Row style={{}}>
                            {this.renderProdutos()}
                        </Row>

                        <div style={{ marginTop: 5, height: 1, backgroundColor: "black" }} />

                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>{this.renderValor(this.state.vlr_prod)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>TOTAL PRODUTOS: </span>
                            </div>
                        </Row>
                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>{this.renderValor(this.state.vlr_serv)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>TOTAL SERVIÇOS: </span>
                            </div>
                        </Row>
                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>{this.renderValor(this.state.vlr_avul)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>TOTAL AVULSOS: </span>
                            </div>
                        </Row>
                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 11, color: "black" }}>{this.renderValor(this.state.vlr_total)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 11, color: "black" }}>TOTAL O.S: </span>
                            </div>
                        </Row>

                        <div style={{ marginTop: 5, height: 1, backgroundColor: "black" }} />

                        <Row style={{ marginLeft: 0, marginTop: 10, fontSize: 9, color: "black" }}>
                            <Col xs={24} style={{ marginTop: 0 }} >
                                <span style={{ fontWeight: 'bold' }}>Vendedor: </span>
                                <span> {usu_nome} </span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 0 }} >
                                <span style={{ fontWeight: 'bold' }}>Cliente: </span>
                                <span> {pes_codigo + ' - ' + pes_nome} </span>
                            </Col>
                            {(pes_fone1 !== '' || pes_fone2 !== '' || pes_fone3 !== '') && (pes_fone1 !== '(  )      -' || pes_fone2 !== '(  )      -' || pes_fone3 !== '(  )      -') ? (
                                <Col xs={24} style={{ marginTop: 0 }} >
                                    <span style={{ fontWeight: 'bold' }}>Fones: </span>
                                    <span> {pes_fone1 !== '' && pes_fone1 !== '(  )      -' ? ' - ' + pes_fone1 : ''} </span>
                                    <span> {pes_fone2 !== '' && pes_fone2 !== '(  )      -' ? ' - ' + pes_fone2 : ''} </span>
                                    <span> {pes_fone3 !== '' && pes_fone3 !== '(  )      -' ? ' - ' + pes_fone3 : ''} </span>
                                </Col>
                            ) : null}
                            <Col xs={24} style={{ marginTop: 0, marginBottom: 10 }} >
                                <span style={{ fontWeight: 'bold' }}>Endereço: </span>
                                <span> {pes_endereco ? pes_endereco : ''} </span>
                                <span> {pes_numero ? ' - ' + pes_numero : ''} </span>
                                <span> {pes_bairro ? ' - ' + pes_bairro : ''} </span>
                                <span> {pes_cep ? ' - ' + pes_cep : ''} </span>
                                <span> {cmun_descricao ? ' - ' + cmun_descricao : ''} </span>
                                <span> {cuf_sigla ? ' - ' + cuf_sigla : ''} </span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 0 }} >
                                <span style={{ fontWeight: 'bold' }}>Solicitante: </span>
                                <span> {os_solicitante} </span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold' }}>Descrição: </span>
                                <span> {os_descricao} </span>
                            </Col>
                            {checkListSelect ? (
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>CheckList: </span>
                                    <span> {this.renderCheckListSelect(checkListSelect)} </span>
                                </Col>
                            ) : null}
                            {oso_defeitos ? (
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>Defeitos Relatados: </span>
                                    <span> {oso_defeitos} </span>
                                </Col>
                            ) : null}
                            {oso_laudo ? (
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>Laudo Técnico: </span>
                                    <span> {oso_laudo} </span>
                                </Col>
                            ) : null}
                        </Row>

                        <div style={{ marginTop: 5, height: 1, backgroundColor: "black" }} />

                        {listaParcelas && listaParcelas.length > 0 ? (
                            <Row style={{ marginTop: 10, marginBottom: 20, fontSize: 12, color: "black" }}>
                                <span style={{ fontWeight: 'bold' }}>PAGAMENTO - {cp_descricao}</span>
                                {this.renderPagamentos()}
                            </Row>
                        ) : null}

                        <Row style={{ padding: 0, fontSize: 9, color: "black" }}>
                            <div className="textoTermosOS2Vias">
                                {usuario.par_termos_os}
                            </div>
                        </Row>

                        <Row className="titulo1" style={{ marginTop: 50, marginBottom: 30, fontSize: 10, color: "black" }} >
                            <Col xs={24} style={{ fontWeight: 'bold' }} >
                                <span>-----------------------------</span>
                            </Col>
                            <Col xs={24} style={{ fontWeight: 'bold' }} >
                                <span>ASSINATURA DO CLIENTE</span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 30, fontSize: 10 }} >
                                <span>Este cupom não é documento fiscal</span>
                            </Col>
                            <Col xs={24} style={{ fontSize: 10 }} >
                                <span>Desenvolvido por</span>
                                <span style={{ fontWeight: 'bold' }}> Plena Sistemas</span>
                            </Col>
                        </Row>

                    </div>

                </PrintModalCupom>
            </span>
        );
    }
}

export default OSPrintCupomModal;



// WEBPACK FOOTER //
// ./src/relatorios/OSPrintCupomModal.js